import { render, staticRenderFns } from "./AddToCartDessert.vue?vue&type=template&id=658e265f&scoped=true&"
import script from "./AddToCartDessert.vue?vue&type=script&lang=js&"
export * from "./AddToCartDessert.vue?vue&type=script&lang=js&"
import style0 from "./AddToCartDessert.vue?vue&type=style&index=0&id=658e265f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658e265f",
  null
  
)

export default component.exports